<template>
    <b-col class="animated fadeIn" sm="6">
        <b-card>
            <b-form @submit="save">
                <InputField type="text" name="name" :label="this.$t('name')" v-model="model.name" @error="fieldError"
                    :rules="{required:true, length: {min: 2}}"
                />

                <SelectField name="Role" :label="this.$t('role')" v-model="model.roles" @error="fieldError" :multiple="true" :items="roles"
                    :rules="{required:true}"
                />


                <b-form-group
                    v-if="!secret"
                    :label-cols="1"
                    :horizontal="true">
                    <button class="btn btn-success float-right" type="submit">{{ $t('save') }}</button>
                </b-form-group>

                <b-form-group
                    v-else
                    :label="$t('secret')"
                    :label-cols="12"
                    :description="$t('apiUserSecretDescription')"
                    :horizontal="true">
                    <b-input :value="secret" disabled />
                </b-form-group>
            </b-form>
        </b-card>
    </b-col>
</template>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"

export default {
    name: "Create",
    components: {
        InputField: Input,
        SelectField: Select
    },
    data: function() {
        return {
            errors: [],
            model: {
                name: "",
                roles: []
            },
            
            secret: null
        }
    },

    computed: {
        items() {
            let project = this.$store.getters.getCurrentProject
            let users = []

            if (project.users !== undefined) {
                project.users.forEach(user => {
                    users.push(user.User)
                });
            }

            return users
        },

        roles() {
            let roles = this.$store.getters.getRoles
            roles.map(el => {
                el.text = el.name
                el.value = el.uuid
            })

            return roles
        }
    },
    methods: {
        save(e) {
            e.preventDefault()
            const popup = this.$loadingPopup()

            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            this.$http.post("/v1/user/api-user", this.model).then((resp) => {
                this.$bvToast.toast(this.$t('success'), {
                    variant: 'success'
                })

                this.secret = resp.data.secrets[0].secret
            }).catch(err => {
                if (err.response.status == 500) {
                    this.$serverErrorModal(err)
                    return
                }

                this.$bvToast.toast(err.response.data.message, {
                    variant: 'danger'
                })
            }).finally(() => popup.hide())
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },
    },
    mounted() {
        this.$store.dispatch("fetchRoles").catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$mainDialog.msgBoxOk(error.response.data.message)
        })
    }
}
</script>
